<template>
    <div class="content-wrapper">
         <app-breadcrumb :page-title="$t('buyer_request_profile')" :directory="$t('datatables')" :icon="'grid'"/>
        <div class="card card-with-search border-0 card-with-shadow">
            <div class="card-body">
                <div class="text-justify">
                    <div class="mb-primary">
                        <app-tab :tabs="tabsHorizontal" type="horizontal"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>
<script>
 export default {
        name: "Tabs",
        components: {},
        data() {
            return {
                icon: 'settings',
                tabsHorizontal: [
                    {
                        "name": "Profile",
                        "component": "request-profile-view",
                        "permission": ""
                    },
                    {
                        "name": "Forms",
                        "component": "request-profile-forms",
                        "permission": ""
                    },
                    {
                        "name": "Status",
                        "component": "request-profile-status",
                        "permission": ""
                    },
                ],
            }
        }
    }
</script>
